export const APP_LOADED = "APP_LOADED";
export const SET_BREADCRUMBS = "SET_BREADCRUMBS";
export const RESET_BREADCRUMBS = "RESET_BREADCRUMBS";
export const GET_USER_ROLES = "GET_USER_ROLES";
export const OPEN_LEFT_NAV = "OPEN_LEFT_NAV";
export const CLEAR_CONTEXT = "CLEAR_CONTEXT";
export const SET_EXPORT_TO_PDF = "SET_EXPORT_TO_PDF";
